<template>
    <form-item-wrapper :widget="widget" :formData="formData" ref="itemref">
        <a-input-number v-model:value="formData[widget.name]" :disabled="widget.options.disabled"
            :placeholder="widget.options.placeholder" :controls="widget.options.controls"
            :bordered="widget.options.bordered" :step="widget.options.step" :min="widget.options.min"
            :max="widget.options.max" @change="handleOnChange" @pressEnter="handleOnPressEnter">
            <template v-if="widget.options.prefixIcon" #prefix>
                <component :is="widget.options.prefixIcon" />
            </template>
        </a-input-number>
    </form-item-wrapper>
</template>

<script setup>
import FormItemWrapper from "./form-item-wrapper.vue";
import { ref, toRefs } from 'vue';
import useEvent from "./useEvent";

const props = defineProps({
    widget: Object,
    formData: Object,
})
const { widget, formData } = toRefs(props)
const itemref = ref(null)

const {
    handleOnChange,
    handleOnPressEnter,
} = useEvent(widget.value, itemref, formData.value);
</script>